<script>
import AppCopyField from '@/common/AppCopyField.vue';
export default {
  name: 'ZelleInstructions',
  components: { AppCopyField },
  props: {
    instructions: { type: Object, default: null },
    saving: Boolean,
    gateway: { type: Object, required: true },
    donationAmount: { type: Number, required: true }
  },
  computed: {
    recipient() {
      return this.instructions?.recipient || this.gateway.keys.recipient;
    },
    recipientName() {
      return this.instructions?.recipientName || this.gateway.keys.recipientName;
    },
    amount() {
      return Number(this.donationAmount).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }
  }
};
</script>

<template>
  <section class="zelle-information my-8" aria-label="Zelle information" :aria-busy="saving">
    <h4 class="body-text-extra-bold">Zelle information</h4>
    <p v-if="instructions && instructions.status !== 'initial'" role="status">This donation has already been recorded. Please do not send another payment.</p>
    <p v-else-if="instructions && instructions.donorReportedSentAt" role="status">
      Your payment report is saved. Please do not send another payment while we verify it.
    </p>
    <template v-else>
      <p class="body-text-semibold">Open Zelle in your banking app and send your payment using the details below.</p>
      <app-copy-field :label="recipient.includes('@') ? 'Zelle email' : 'Zelle phone'" :value="recipient" />
      <app-copy-field label="Recipient" :value="recipientName" />
      <div class="zelle-information-details">
        <app-copy-field label="Amount" :value="amount" :copy-value="Number(donationAmount).toFixed(2)" />
        <app-copy-field label="Memo" :value="instructions ? instructions.reference : ''" :loading="!instructions" />
      </div>
    </template>
  </section>
</template>
